export const UploadFileUrl =
  "api/gateway/object_store.object_store.PutObject/api/v1/objectStore/bucket/cmdb-bucket/object";

export const DownloadFileUrl =
  "api/gateway/object_store.object_store.GetObject/api/v1/objectStore/bucket/cmdb-bucket/object";
